import { axiosClient } from "@/shared/api/axios-client";
import type { UsuarioAdmin } from "@/lib/types";

export interface ListarUsuariosParams {
  busqueda?: string;
  rol?: string;
  organizacionId?: string;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + total del catálogo completo para el header. */
export interface PaginaUsuarios {
  items: UsuarioAdmin[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
}

export async function listarUsuariosAdmin(
  params: ListarUsuariosParams = {}
): Promise<PaginaUsuarios> {
  const { data } = await axiosClient.get<PaginaUsuarios>("/api/admin/usuarios", {
    params,
  });
  return data;
}

export async function cambiarNombreUsuario(
  usuarioId: string,
  fullName: string | null
): Promise<void> {
  await axiosClient.put(`/api/admin/usuarios/${usuarioId}/nombre`, { fullName });
}

export async function cambiarRolesUsuario(
  usuarioId: string,
  roles: string[]
): Promise<void> {
  await axiosClient.put(`/api/admin/usuarios/${usuarioId}/roles`, { roles });
}

export async function cambiarAreasUsuario(
  usuarioId: string,
  areaIds: string[]
): Promise<void> {
  await axiosClient.put(`/api/admin/usuarios/${usuarioId}/areas`, { areaIds });
}

export async function cambiarOrganizacionesUsuario(
  usuarioId: string,
  organizacionIds: string[]
): Promise<void> {
  await axiosClient.put(`/api/admin/usuarios/${usuarioId}/organizaciones`, {
    organizacionIds,
  });
}
